import { render } from "./VideoLoadingComponent.vue?vue&type=template&id=0733dff0&scoped=true&ts=true"
import script from "./VideoLoadingComponent.vue?vue&type=script&lang=ts"
export * from "./VideoLoadingComponent.vue?vue&type=script&lang=ts"

import "./VideoLoadingComponent.vue?vue&type=style&index=0&id=0733dff0&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0733dff0"]])

export default __exports__